import dayJs from 'dayjs';
import { FormatType, DataType } from '@constants/detail';
import { CCORIGIN } from 'constants/address';
import { getQueryString, formatDuration, formatAmount } from '@utils/tool';

export const getTimeFormat = () => {
  const region = new URLSearchParams(window.location.search).get('region') || '';

  if (!region) {
    return 'YYYY-MM-DD';
  }

  const eu5 = ['gb', 'fr', 'de', 'it', 'es'];

  return [...eu5, 'us'].includes(region.toLowerCase()) ? 'DD/MM/YYYY' : 'YYYY-MM-DD';
};

export function formatNumber(num: number) {
  if (num < 1e3) {
    return `${num}`;
  }

  num = num || 0;
  const k = num < 1e6;
  const m = num >= 1e6 && num < 1e9;

  const numDigits = `${num / (k ? 1e3 : m ? 1e6 : 1e9)}`.split('.');
  const integer = numDigits[0] || 0;
  const float = (numDigits[1] || '0').slice(0, 1);

  return `${integer}${float !== '0' ? `.${float}` : ''}${k ? 'K' : m ? 'M' : 'B'}`;
}

export const formatData = (value: any, type?: FormatType | DataType) => {
  if (!type) {
    return value;
  }
  if (type === FormatType.Date) {
    console.log(value);
    return dayJs.unix(value).format('YYYY/MM/DD');
  } else if (type === FormatType.Duration) {
    return formatDuration(value);
  } else if (type === FormatType.Amount) {
    return formatAmount(value);
  } else if (type === FormatType.Link) {
    const region = getQueryString('region');
    return `${CCORIGIN}?template_id=${value}&region=${region}`;
  } else if (type === DataType.SortSource) {
    return value ? 'Operation Boost' : 'Original sort';
  } else {
    return value;
  }
};
